
import {createSlice} from "@reduxjs/toolkit";

export const financialSlice = createSlice({
    name: 'financialSlc',
    initialState: {value: {id: null, fileId: null, account: null, adjustFrom: null, adjustTo: null,
            adjustNote: null, amount: null, displayAmount: null, amountType: null, financialMarket: null,
            languageCode: null, licenseId: null, periodEndDate: null, propertyId: null,
            sourceSystem: null, sourceSystemId: null, territory: null, units: null,
            status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            licenseAmount: null, licenseDisplayAmount: null, availBegin: null,
            availEnd: null, executionDate: null, licensee: null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            stakeholderId: null, contractId: null,
            financialDrawerState: false, financialDrawerMode: null, financialGridRefresh: false
        }},
    reducers:

{
    changeFinancial: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeFinancial } = financialSlice.actions;

export default  financialSlice.reducer ;
